module.exports = __webpack_public_path__ + "img/diploma2.57921fe9.jpg";